'use client';

import { useEffect, useState } from 'react';
import api from '@/lib/api';

type InvitePreview = {
  inviterName: string;
  albumTitle: string;
};

type InviteContextBannerProps = {
  inviteToken: string | null;
};

export default function InviteContextBanner({ inviteToken }: InviteContextBannerProps) {
  const [preview, setPreview] = useState<InvitePreview | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!inviteToken) {
      setPreview(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    api.invites
      .preview(inviteToken)
      .then((res) => {
        if (!cancelled && res?.data) {
          setPreview({
            inviterName: res.data.inviterName,
            albumTitle: res.data.albumTitle
          });
        }
      })
      .catch(() => {
        if (!cancelled) setPreview(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [inviteToken]);

  if (!inviteToken) return null;

  return (
    <div className="invite-context-banner" aria-live="polite">
      <div className="invite-context-banner__ring" aria-hidden />
      <div className="invite-context-banner__body">
        <p className="invite-context-banner__eyebrow">协作邀请</p>
        {loading && !preview ? (
          <p className="invite-context-banner__title">正在加载邀请信息…</p>
        ) : preview ? (
          <>
            <p className="invite-context-banner__title">
              <span className="invite-context-banner__name">{preview.inviterName}</span>
              {' '}邀请你加入
            </p>
            <p className="invite-context-banner__album">《{preview.albumTitle}》</p>
          </>
        ) : (
          <p className="invite-context-banner__title">你收到了一份音乐协作邀请</p>
        )}
      </div>
    </div>
  );
}
